import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { LuLightbulb, LuTrendingUp, LuShield, LuZap } from 'react-icons/lu';

function UtilityProactivePlanning() {
        const [cardRef, isCardVisible] = useScrollAnimation({ threshold: 0.2, triggerOnce: true });

    
    const features = [
        {
            icon: <LuTrendingUp className="text-blue-600" size={32} />,
            title: "Predictive Analytics",
            description: "Anticipate future grid capacity needs before they become critical issues."
        },
        {
            icon: <LuShield className="text-green-600" size={32} />,
            title: "Risk Mitigation",
            description: "Identify potential bottlenecks and vulnerabilities in your distribution network."
        },
        {
            icon: <LuZap className="text-purple-600" size={32} />,
            title: "Strategic Investment",
            description: "Optimize infrastructure investments with data-driven planning recommendations."
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50">
                <div className="p-8 max-w-7xl mx-auto">
                    <div
                        ref={cardRef}
                        className={`bg-white rounded-xl shadow-lg p-10 mt-[5vh] transition-all duration-1000 ease-out transform ${
                            isCardVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                        }`}
                    >
                        {/* Header Section */}
                        <div className="text-center mb-8">
                            <div className="flex items-center justify-center mb-4">
                                <LuLightbulb className="text-blue-600" size={48} />
                            </div>
                            <h1 className="text-4xl font-bold text-gray-800 pb-4 font-ui">
                                Proactive Planning
                            </h1>
                            <div className="inline-block bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                                Coming Soon
                            </div>
                        </div>

                        {/* Introduction */}
                        <p className="text-lg text-gray-700 leading-relaxed pb-5 font-ui">
                            Transform your grid planning approach from reactive to proactive. Our Proactive Planning module will empower you to stay ahead of EV adoption trends and infrastructure demands, ensuring your grid is ready for the future.
                        </p>

                        {/* Call to Action */}
                        <div className="bg-white border-2 border-blue-200 rounded-lg p-6 text-center">
                            <p className="text-lg text-gray-700 font-ui mb-4">
                                While this feature is under development, explore our <strong>Scenario Results</strong> to analyze current and projected grid impacts from EV adoption.
                            </p>
                            <p className="text-sm text-gray-600 font-ui">
                                Have specific requirements or feedback? <a href="mailto:info@amptrans.com" className="text-blue-600 hover:text-blue-700 underline">Contact us</a> to help shape this feature.
                            </p>
                        </div>
                    </div>
                </div>
        </div>
    );
}

export default UtilityProactivePlanning;
